export enum EApplicationStatus {
  READY_FOR_PAY = 10,
  PAYING = 20,
  PAID = 30,
  REJECT = 40,
  FAIL = 50,
  WALLET_FAIL = 60,
  EXPIRED = 70,
}

export function codeToStatus(code: string): EApplicationStatus {
  switch (code) {
    case '10':
      return EApplicationStatus.READY_FOR_PAY
    case '20':
      return EApplicationStatus.PAYING
    case '30':
      return EApplicationStatus.PAID
    case '40':
      return EApplicationStatus.REJECT
    case '50':
      return EApplicationStatus.FAIL
    case '60':
      return EApplicationStatus.WALLET_FAIL
    case '70':
      return EApplicationStatus.EXPIRED
    default:
      throw new Error('Invalid status code')
  }
}
